/**
 * Valore Immobiliare — magazine editoriale interno.
 *
 * Struttura semplice e locale: ogni articolo è un oggetto con
 * metadata + blocks tipizzati. Il layout li rende senza CMS/backoffice.
 * Aggiungere un articolo = importare qui il modulo nel folder
 * ``articles/`` e appenderlo ad ``ARTICLES``. Le categorie compaiono
 * nell'indice solo se contengono almeno un articolo pubblicato.
 */
import quantoValeDavveroUnaCasa from "./articles/quanto-vale-davvero-una-casa";
import casaEreditataSetteVerifiche from "./articles/casa-ereditata-sette-verifiche";

export const MAGAZINE_META = {
  name: "Valore Immobiliare",
  tagline: "Capire la casa. Decidere meglio.",
  signature: "Un progetto ValutaGenio",
  base_path: "/valore-immobiliare",
};

/** Canonical category list; the index shows ALL categories as filters,
 *  even those without articles yet (empty state shown when selected). */
export const CATEGORIES = [
  { slug: "valore-e-mercato",           label: "Valore e mercato" },
  { slug: "eredita-e-comproprieta",     label: "Eredità e comproprietà" },
  { slug: "ristrutturare-e-valorizzare", label: "Ristrutturare e valorizzare" },
  { slug: "affitto-e-messa-a-reddito",  label: "Affitto e messa a reddito" },
  { slug: "documenti-e-burocrazia",     label: "Documenti e burocrazia" },
  { slug: "fisco-e-finanza-immobiliare", label: "Fisco e finanza immobiliare" },
];

/** Newest first. */
export const ARTICLES = [
  quantoValeDavveroUnaCasa,
  casaEreditataSetteVerifiche,
];

export function getArticleBySlug(slug) {
  return ARTICLES.find((a) => a.slug === slug) || null;
}

export function getCategoryLabel(slug) {
  return (CATEGORIES.find((c) => c.slug === slug) || {}).label || slug;
}

export function getAllCategories() {
  return CATEGORIES;
}

export function getArticlesByCategory(slug) {
  if (!slug) return ARTICLES;
  return ARTICLES.filter((a) => a.category_slug === slug);
}

export function getPublishedCategories() {
  const used = new Set(ARTICLES.map((a) => a.category_slug));
  return CATEGORIES.filter((c) => used.has(c.slug));
}

export function getLatestArticles(limit = 2) {
  return ARTICLES.slice(0, limit);
}

export function getSiblingArticle(currentSlug) {
  const idx = ARTICLES.findIndex((a) => a.slug === currentSlug);
  if (idx < 0) return null;
  const sibling = ARTICLES[(idx + 1) % ARTICLES.length];
  return sibling && sibling.slug !== currentSlug ? sibling : null;
}
